import { useEffect, useState } from 'react'; 
import { getDealerCompaniesByManufacturer } from '@/utils/services/dealer-companies';
import { TDealerCompanies } from '@/types/v2/dealer-companies';

export const useGetDealerCompanies = (manufacturerId: string | undefined) => {
  const [dealerCompanies, setDealerCompanies] = useState<TDealerCompanies[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDealerCompanies = async () => {
      if (!manufacturerId) { 
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await getDealerCompaniesByManufacturer(manufacturerId)
        setDealerCompanies(response);
      } catch (err) {
        setError('Error fetching dealer companies');
      } finally {
        setLoading(false);
      }
    };

    fetchDealerCompanies();
  }, [manufacturerId]);

  return { dealerCompanies, loading, error };
};
